import { cn } from "@gsa/ui/lib/utils";

import { inter, robotoSlab } from "~/lib/fonts";

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function H1({ children, className }: Props) {
  return (
    <h1 className={cn("text-5xl font-bold", className, robotoSlab.className)}>
      {children}
    </h1>
  );
}

export function H2({ children, className }: Props) {
  return (
    <h2 className={cn("text-2xl font-bold", className, robotoSlab.className)}>
      {children}
    </h2>
  );
}

export function H3({ children, className }: Props) {
  return (
    <h3 className={cn("text-xl font-bold", robotoSlab.className, className)}>
      {children}
    </h3>
  );
}

export function H4({ children, className }: Props) {
  return (
    <h4 className={cn("text-lg font-bold", robotoSlab.className, className)}>
      {children}
    </h4>
  );
}

export function H5({ children, className }: Props) {
  return (
    <h5 className={cn("text-base font-bold", robotoSlab.className, className)}>
      {children}
    </h5>
  );
}

export function H6({ children, className }: Props) {
  return (
    <h6 className={cn("text-sm font-bold", robotoSlab.className, className)}>
      {children}
    </h6>
  );
}

export function P({ children, className }: Props) {
  return (
    <p
      className={cn(
        "text-base text-muted-foreground",
        inter.className,
        className,
      )}
    >
      {children}
    </p>
  );
}

export function Small({ children, className }: Props) {
  return <small className={cn("text-sm", className)}>{children}</small>;
}

export function Span({ children, className }: Props) {
  return <span className={cn("text-sm", className)}>{children}</span>;
}
